import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "mb-3 cursor-pointer" }
const _hoisted_2 = { class: "block text-white/90 text-base leading-[1.18rem] mb-3 pl-[10px]" }
const _hoisted_3 = { class: "'w-full h-[44px] hover:bg-[#2A323B] bg-[#22282F] rounded-[10px] px-3 border-2 border-transparent focus:border-[#6CBFFF] text-white flex items-center gap-2" }
const _hoisted_4 = ["src"]

import {computed} from "vue";
import { useLanguages } from '@/composables/useLanguages'
import { Constants } from '@/cfg/constants'


export default /*@__PURE__*/_defineComponent({
  __name: 'LanguageInput',
  props: {
    initial: { default: Constants.DEFAULT_LANGUAGE },
    label: { default: "profile_language" }
  },
  setup(__props: any) {

const { languages } = useLanguages()

const props = __props

const selectedLangCode = computed(() => props.initial || Constants.DEFAULT_LANGUAGE)

const getUserLanguage = computed(() => {
  let selectedLang = false;

  languages.value.forEach(lang => {
    if (lang.code == selectedLangCode.value && lang.dialects.length <= 1) {
      selectedLang = lang;
      return;
    } else {
      lang.dialects.forEach(dialect => {
        if (dialect.code == selectedLangCode.value) {
          selectedLang = dialect;
          return;
        }
      });
    }
  });
  return selectedLang;
})


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("label", _hoisted_2, _toDisplayString(_ctx.$t(__props.label)), 1),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("img", {
        src: '/data/flags/' + getUserLanguage.value.code + '.png',
        alt: "",
        class: "w-4 h-4 rounded-full overflow-hidden"
      }, null, 8, _hoisted_4),
      _createElementVNode("span", null, _toDisplayString(getUserLanguage.value.name), 1)
    ])
  ]))
}
}

})